export interface ILayoutResourceStrings {
    name: string,
    add: string,
    addUsers: string,
    addComment: string,
    userName: string,
    units: string,
    cleaningtype: string,
    selectUnit: string,
    selectType: string,
    addbtn: string,
    comment: string,
    back: string,
    commentplaceholder: string
}

export interface ILayoutResources {
    [key: string]: ILayoutResourceStrings,
}

const engb = "en-GB";
const etee = "et-EE";

export const CleaningFormTranslations: ILayoutResources = {
    [engb]: {
        name: "Name",
        add: "Add warehouse cleaning task",
        addUsers: "Add employees",
        addComment: "Add comment",
        userName: "Employee name",
        units: "Unit",
        cleaningtype: "Task type",
        addbtn: "Add",
        selectType: "Select task type",
        selectUnit: "Select unit",
        comment: "Comment",
        back: "Back",
        commentplaceholder: "Add a comment ..."
    },
    [etee]: {
        name: "Nimi",
        add: "Lisa laopuhastustöö",
        addUsers: "Lisa töötajaid",
        userName: "Töötaja nimi",
        addComment: "Lisa kommentaar",
        units: "Ladu",
        cleaningtype: "Tegevus",
        addbtn: "Lisa",
        selectType: "Vali tegevusliik",
        selectUnit: "Vali ladu",
        comment: "Kommentaar",
        back: "Tagasi",
        commentplaceholder: "Lisa kommentaar ..."
    },
}

export default CleaningFormTranslations;